export const colors = {
  red: '#ff0000',
  green: '#00ff0a',
  yellow: '#ffc107'
}
